import React from "react";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
const ErrorRuleConfirmation = ({ showerrorruleconfirmpopup, handleCloseerrorruleconfirmpopup }) => {
    return (<>
        <Modal show={showerrorruleconfirmpopup} onHide={handleCloseerrorruleconfirmpopup}>
            <Modal.Body>
                <p className="text-danger text-uppercase"> <i class="ri-error-warning-fill"></i> TO Create a Client Field required details are missing so can't create client field</p>
                <p>Do you want to Download the result</p>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="secondary" onClick={handleCloseerrorruleconfirmpopup}>
                    Close
                </Button>
                <Button variant="primary" onClick={handleCloseerrorruleconfirmpopup}>
                    Ok
                </Button>
            </Modal.Footer>
        </Modal>
    </>)
}
export default ErrorRuleConfirmation